<script lang="ts">
	import UserInteract from './UserInteract.svelte';
	import { longOrShort } from './store';
	import BedrockNote from './BedrockNote.svelte';
	import { isItBedrockTime } from '../util';
</script>

<div
	class="bg-fx-gradient-8-50 flex items-center flex-col p-2 sm:p-4 w-full border-t border-fx-grey-500 min-h-full relative"
	class:long={$longOrShort == 'Long'}
	class:short={$longOrShort == 'Short'}
>
	<UserInteract />
	{#if isItBedrockTime()}
		<BedrockNote />
	{/if}
</div>

<style>
	.short {
		background: linear-gradient(180deg, rgba(221, 64, 116, 0.2) 3.86%, rgba(0, 0, 0, 0) 17.9%),
			linear-gradient(132.03deg, rgba(21, 24, 37, 0.5) 0%, rgba(11, 10, 7, 0.5) 100%);
	}

	.long {
		background: linear-gradient(180deg, rgba(12, 88, 81, 0.2) 3.86%, rgba(0, 0, 0, 0) 17.9%),
			linear-gradient(132.03deg, rgba(21, 24, 37, 0.5) 0%, rgba(11, 10, 7, 0.5) 100%);
	}
</style>
